import dayjs from 'dayjs';
import { StatDay, StatDayFromHttp, StatDays, StatDaysFromHttp, TrainingLogMonth, TrainingLogMonthHttp } from '../models/stats.model';

export function transformDaysStatsFromApiToUsableStatsDays(statDays: StatDaysFromHttp, startDate, endDate): StatDays {
  const creationTimestamp = Date.now();
  const dayStartDate = dayjs(startDate);
  const dayEndDate = dayjs(endDate);
  // +1 To have inclusive interval, take last day : [start;end]
  const nbDaysInterval = dayEndDate.diff(dayStartDate, 'day') + 1;
  if (nbDaysInterval <= 0) {
    return [];
  }
  const formatedStatsDays: StatDays = new Array(nbDaysInterval);

  let tmpDayDate = dayStartDate.clone();
  for (let i = 0; i < nbDaysInterval; ++i) {
    const dateKey = tmpDayDate.format('YYYY-MM-DD');
    // If state day does not exist it creates an empty stat day inplace
    if (statDays[dateKey]) {
      formatedStatsDays[i] = dayStatFromApiToDayState(statDays[dateKey], creationTimestamp);
    } else {
      // Empty day
      formatedStatsDays[i] = {
        date: dateKey,
        nbSessions: 0,
        elapsedTime: 0,
        distance: 0,
        createdAt: creationTimestamp
      };
    }
    tmpDayDate = tmpDayDate.add(1, 'day');
  }
  return formatedStatsDays;
}

export function dayStatFromApiToDayState(statDay: StatDayFromHttp, creationTimestamp: number): StatDay {
  return {
    date: statDay.day,
    nbSessions: statDay.nb_sessions,
    elapsedTime: statDay.elapsed_time,
    distance: statDay.total_distance,
    createdAt: creationTimestamp,
  };
}

export function transformTraningLogMonthToTrainingLogMonthNubmer(trainingLogMonth: TrainingLogMonthHttp): TrainingLogMonth {
  return {
    ...trainingLogMonth,
    month: parseInt(trainingLogMonth.month, 10)
  };
}
